import { ConditionalRuleBuiltInValueType } from "~/models/conditionalRules/conditionalRuleBuiltInValueType";
import IConditionalRuleReferencedControl from "~/models/conditionalRules/referencedControl";
import { DatetimeMode } from "../datetimeMode";
import Model from "../model";
import { ComparisonType } from "./comparisonType";
import { TargetType } from "./targetType";
import {IConditionalRuleBuiltInValuable} from "~/interfaces/conditionalRuleBuiltInValuableInterfaces";

export interface IBuiltInReferencedValueRuleRootModel extends Pick<IConditionalRuleBuiltInValuable, 'builtInValueChoiceComparisonOptions'> {}

export default class BuiltInReferencedValue extends Model implements IConditionalRuleReferencedControl {
  client_id: string;
  referenceNameOrDefault: string;
  value_type: ConditionalRuleBuiltInValueType
  isValidForConditionalLogic: boolean;
  ruleRootModel: IBuiltInReferencedValueRuleRootModel;

  constructor(value_type: ConditionalRuleBuiltInValueType, ruleRootModel: IBuiltInReferencedValueRuleRootModel) {
    super();
    this.value_type = value_type;
    this.isValidForConditionalLogic = true
    this.ruleRootModel = ruleRootModel;
  }

  targetTypes(): TargetType[] {
    return [TargetType.value]
  };

  displayConditionType(targetType: TargetType): ComparisonType {
    switch (this.value_type) {
      case ConditionalRuleBuiltInValueType.CreatedAt:
      case ConditionalRuleBuiltInValueType.UpdatedAt:
      case ConditionalRuleBuiltInValueType.FormSubmissionOriginalSubmittedAt:
      case ConditionalRuleBuiltInValueType.FormSubmissionStepSubmittedOnDate:
        return ComparisonType.datetime;
      case ConditionalRuleBuiltInValueType.RecordHolderName:
      case ConditionalRuleBuiltInValueType.CreatedBy:
      case ConditionalRuleBuiltInValueType.RecordHolderEmail:
      case ConditionalRuleBuiltInValueType.FormSubmissionDisplaySubmissionId:
      case ConditionalRuleBuiltInValueType.FormSubmissionProxySubmitterEmail:
      case ConditionalRuleBuiltInValueType.FormSubmissionSubmitterFirstName:
      case ConditionalRuleBuiltInValueType.FormSubmissionSubmitterLastName:
      case ConditionalRuleBuiltInValueType.FormSubmissionSubmitterEmail:
        return ComparisonType.text
      case ConditionalRuleBuiltInValueType.FormSubmissionApplicationStatus:
      case ConditionalRuleBuiltInValueType.FormSubmissionStepPaymentMethod:
        return ComparisonType.singleChoice;
    }
  }

  getChoiceComparisonOptions(): any[] {
    return this.ruleRootModel.builtInValueChoiceComparisonOptions(this.value_type);
  };

  getConditionDateTimeMode(): DatetimeMode {
    return DatetimeMode.Datetime
  };

  getConditionMinDateTime(): string {
    return null;
  }

  getConditionMaxDateTime(): string {
    return null;
  }
}